export default {"src":"/evde-internet/_next/static/media/right-confeti.8539278d.svg","height":128,"width":169};